module.exports = __webpack_public_path__ + "img/new-game.6bcf3e38.png";